import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { ActivityState } from '../../../shared/enums';
import { PresentationController } from '../../presentation-controller';
import { ScrollContentDirective } from '../../scroll-content.directive';

@Component({
  selector: 'ds-table-layout',
  imports: [TranslatePipe, ScrollContentDirective],
  templateUrl: './table-layout.component.html',
  styleUrls: ['./table-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableLayoutComponent {
  public readonly cancelled = ActivityState.Cancelled;
  public readonly controller = input.required<PresentationController>();
  public readonly activities = computed(() => this.controller().slide.content.activities ?? []);
}
